export default {
  CLEAR_BILLING(state) {
    state.billings = {};
    state.actual = null;
  },
  SET_NEW_BILLING(state, {
    id
  }) {
    state.billings = {
      id,
      emisor: {
        mandanteIut: null
      },
      receptor: {
        iut: null,
        razonSocial: null,
        giro: null
      },
      detalle: {
        monto: '0',
        moneda: 'CLP',
        descripcion: ''
      },
      personalizados: {}
    };
  },
  SET_BILLING_INFORMATION(state, {
    id,
    emisor,
    receptor,
    detalle,
    personalizados = [],
    referencias = []
  }) {
    state.billings = {
      id,
      emisor,
      receptor,
      detalle,
      referencias,
      personalizados: personalizados.reduce((acc, item) => ({
        ...acc,
        [item.nombre]: item
      }), {})
    };
  },
  SET_ACTUAL_BILLING(state, {
    id
  }) {
    state.actual = id;
  },
  SET_DATA(state, data) {
    state.billings = {
      ...state.billings,
      ...data,
      id: state.actual
    };
  },
  SET_SAVING(state,
    saving) {
    state.saving = saving;
  },
  SET_LOADING(state,
    loading) {
    state.loading = loading;
  },
  SET_LOADING_DATA(state,
    loadingData) {
    state.loadingData = loadingData;
  },
  SET_PAGINATION(state, {
    items,
    pages
  }) {
    state.pagination = {
      items,
      pages
    };
  },
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_ACTUAL_FILTER(state, actualFilter) {
    state.actualFilter = actualFilter;
  },
  SET_BINNACLE(state, binnacle) {
    state.binnacle = binnacle;
  }
};
